import pathOr from 'ramda/es/pathOr';

export default err => pathOr(null, ['response', 'status'], err);
